<template>
  <ProtocolRulesThree></ProtocolRulesThree>
</template>

<script>
import ProtocolRulesThree from "@/components/ProtocolRulesThree";
export default {
  components: {
    ProtocolRulesThree,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/taskCenter/taskCenter.vue